module.exports = __webpack_public_path__ + "img/Stemness-BRCA_her2st.79f3bb53.png";